module.exports = __webpack_public_path__ + "img/icon.7497f6b.png";